import { Avatar, IconButton, Stack, Typography, Menu, MenuItem, styled, Divider } from "@mui/material";
import React from "react";
import { APP_ICONS, APP_IMAGES } from "../../assets";
import Notifications from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom";
const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: theme.spacing(1),
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    minWidth: 200,
    backgroundColor: theme.palette.background.default,
    BorderColor: "primary.light"
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
  "&:focus": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

const CustomBar = ({ title }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate("/profile");
    handleClose();
  };

  const handleLogoutClick = () => {
    navigate("/login");
    handleClose();
  };

  return (
    <Stack
      py={1}
      px={2}
      mb={3}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgColor={"secondary.light"}
      borderRadius={"6px"}
      boxShadow={1}
    >
      <Typography variant={"h5"} fontWeight={600} color={"primary.light"}>
        {title}
      </Typography>
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <IconButton
          sx={{
            backgroundColor: 'primary.bgLight',
            padding: "2px",
          }}
        >
          <Notifications fontSize="large" sx={{ color: "primary.main" }} />
        </IconButton>
        <IconButton onClick={handleClick} sx={{ p: 0 }}>
          <Avatar src={APP_IMAGES.dumyUserImg} alt="User Avatar" />
        </IconButton>
        <StyledMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <StyledMenuItem onClick={handleProfileClick}>Profile</StyledMenuItem>
          <Divider />
          <StyledMenuItem onClick={handleLogoutClick}>Logout</StyledMenuItem>
        </StyledMenu>
      </Stack>
    </Stack>
  );
};
export default CustomBar;